import { Image } from 'expo-image';
import { StyleSheet, Text, View } from 'react-native';

import logoSource from '../../assets/images/mcqgen-logo.png';

const highlights = [
  {
    title: 'Instant generation',
    description: 'Turn a topic into a structured MCQ set with less manual formatting.',
  },
  {
    title: 'Exam-ready flow',
    description: 'Keep question creation, review, and practice aligned in one place.',
  },
  {
    title: 'Smart refinement',
    description: 'Adjust difficulty and tone without rewriting from scratch.',
  },
];

export default function HomeScreen() {
  return (
    <View style={styles.screen}>
      <View style={styles.heroCard}>
        <View style={styles.logoWrap}>
          <Image source={logoSource} contentFit="contain" style={styles.logo} />
        </View>
        <View style={styles.heroCopy}>
          <Text style={styles.eyebrow}>MCQGen Workspace</Text>
          <Text style={styles.title}>Your AI co-pilot for cleaner question banks.</Text>
          <Text style={styles.subtitle}>
            Start generating better multiple-choice content with a faster, more focused setup.
          </Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Why this works</Text>
        {highlights.map((item) => (
          <View key={item.title} style={styles.featureCard}>
            <Text style={styles.featureTitle}>{item.title}</Text>
            <Text style={styles.featureBody}>{item.description}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: '#F4F8F1',
    paddingHorizontal: 20,
    paddingTop: 72,
    paddingBottom: 24,
    gap: 24,
  },
  heroCard: {
    borderRadius: 30,
    backgroundColor: '#0B1A11',
    padding: 22,
    gap: 20,
  },
  logoWrap: {
    alignSelf: 'center',
    width: 156,
    height: 156,
    borderRadius: 38,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(120, 209, 45, 0.12)',
  },
  logo: {
    width: 132,
    height: 132,
  },
  heroCopy: {
    gap: 10,
  },
  eyebrow: {
    color: '#A4E97A',
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.9,
    textTransform: 'uppercase',
  },
  title: {
    color: '#F9FCF8',
    fontSize: 29,
    lineHeight: 35,
    fontWeight: '800',
  },
  subtitle: {
    color: '#B2C2B6',
    fontSize: 15,
    lineHeight: 22,
  },
  section: {
    gap: 12,
  },
  sectionTitle: {
    color: '#142018',
    fontSize: 20,
    fontWeight: '800',
  },
  featureCard: {
    borderRadius: 22,
    backgroundColor: '#FFFFFF',
    padding: 18,
    gap: 6,
  },
  featureTitle: {
    color: '#142018',
    fontSize: 16,
    fontWeight: '700',
  },
  featureBody: {
    color: '#647268',
    fontSize: 14,
    lineHeight: 21,
  },
});
